module.exports = __webpack_public_path__ + "img/chev-right.0471937c.svg";